
import { TweenLite } from "gsap";
import { LogGroup, Log, now } from "../.././MyHelpers";
import { Acceleration } from "../SpinAnimation/Acceleration";
import { Anticipation } from "../SpinAnimation/Anticipation";
import { AnticipationParams } from "../SpinAnimation/AnticipationParams";
import { ConstantSpeed } from "../SpinAnimation/ConstantSpeed";
import { Decceleration } from "../SpinAnimation/Decceleration";
import { Overshoot } from "../SpinAnimation/Overshoot";
import { SpinAnimParams } from "../../SpeedManager";


// export namespace S2
// {
export enum S2_ReelSpinAnimState {
	Created,

	Idle,
	Acceleration,
	ConstantSpeed,
	// standard delay
	Delay,
	// anticipation delay is shorter delay, so we can start anticipation in the last interval
	AnticipationDelay,
	Anticipation,
	Decceleration,
	Overshoot,

	Finished,
}

export class S2_OnDeccelerationParams {

	// remaining distance from current position to end
	//distanceToEnd: number = 0;

	// total calculated animation spin distance from beginning to end
	totalDistance: number = 0;
	totalDistanceInSymbols: number = 0;

	constructor(totalDistance: number, totalDistanceInSymbols: number) {
		this.totalDistance = totalDistance;
		this.totalDistanceInSymbols = totalDistanceInSymbols;
	}
}

export interface S2_ReelSpinAnimParams
{
	columnIndex: number;
	logGroup: LogGroup;
	symbolHeightInPixels: number;
	overshootHeightInSymbols: number;
	deccelerationHeightInSymbols: number;
	//symbolSize: Size;
	//windowSize: Size;
	//windowSymbolSize: Size;
	//extendedWindowSymbolSize: Size;
	speedFactor?: number;
	//duration?: number;
	delay?: number;
	speedCorrection?: number;
	durationCorrection?: number;
}

export interface S2_ReelSpinAnimationUpdateParams
{
    reelSpinAnimation: S2_ReelSpinAnimation,
    totalDistance: number;
    symbolDistance: number;
    modSymbolDistance: number;
}

export type S2_ReelSpinAnimationUpdateCallback = (params: S2_ReelSpinAnimationUpdateParams) => void;
export type S2_ReelSpinAnimationDeccelerationCallback = (ReelSpinAnimation: S2_ReelSpinAnimation, deccelerationParams: S2_OnDeccelerationParams) => void;
export type S2_ReelSpinAnimationStartCallback = (ReelSpinAnimation: S2_ReelSpinAnimation) => void;
export type S2_ReelSpinAnimationCompleteCallback = (ReelSpinAnimation: S2_ReelSpinAnimation) => void;
export type S2_ReelSpinAnimationNearCompleteCallback = (ReelSpinAnimation: S2_ReelSpinAnimation) => void;

export class S2_ReelSpinAnimation {

	private logGroup: LogGroup = null;
	public readonly ColumnIndex: number = 0;
	//private symbolHeight: number = 0;
	//private reelWindowHeight: number = 0;

	private state: S2_ReelSpinAnimState = S2_ReelSpinAnimState.Created;
	private startTime: number = 0;

	private lastStateTime: number = 0;
	private lastStateDistance: number = 0;

	private acceleration: Acceleration = null;
	private constantSpeed: ConstantSpeed = null;
	private anticipation: Anticipation = null;
	private decceleration: Decceleration = null;
	private overshoot: Overshoot = null;

	private nearCompleteDistance: number = 0;
	private nearCompleteTargetDistance: number = 0;;
	private nearCompleteTriggeredFlag: boolean = false;

	// where do we stop at?
	private targetSet: boolean = false;
	private stopRequest: boolean = false;
	private reqAnticipation: boolean = false;

	private distance: number = 0;
	// at what distance do we splice animation to target reel position
	private spliceDistance: number = 0;


	private onStartCallbacks: S2_ReelSpinAnimationStartCallback[] = [];
	private onCompleteCallbacks: S2_ReelSpinAnimationCompleteCallback[] = [];
	private onStopAvailableCallbacks: ((reelIndex: number) => void)[] = [];
	private onUpdateCallbacks: S2_ReelSpinAnimationUpdateCallback[] = [];

	private onAnticipationBeginCallbacks: ((e: AnticipationParams) => void)[] = [];
	private onAnticipationEndCallbacks: ((e: AnticipationParams) => void)[] = [];

	private previousReelSpinEnded: boolean = false;

	//private symbolSize: Size = null;
	private symbolHeightInPixels: number = 0;
	//private windowSize: Size = null;
	//private windowSymbolSize: Size = null;
	//private extendedWindowSymbolSize: Size = null;

	protected readonly defaultParams: Partial<S2_ReelSpinAnimParams> = {
		speedFactor: 1,
		//duration: 0,
		delay: 0,
		speedCorrection: 1,
		durationCorrection: 1,
	};

	protected params: S2_ReelSpinAnimParams = null;

	public constructor(params: S2_ReelSpinAnimParams) {

		this.params = {...this.defaultParams, ...params};

		this.ColumnIndex = this.params.columnIndex;

		this.logGroup = this.params.logGroup.Add(["S2.ReelSpinAnim", "" + this.ColumnIndex]);

		

		//this.symbolSize = this.params.symbolSize;
		//this.windowSize = this.params.windowSize;
		//this.windowSymbolSize = this.params.windowSymbolSize;
		//this.extendedWindowSymbolSize = this.params.extendedWindowSymbolSize;
		this.symbolHeightInPixels = Math.round(this.params.symbolHeightInPixels);

        this.CalculateAnimation(this.params.delay, this.params.speedCorrection)



	}

	protected CalculateAnimation(delay:number, speedCorrection:number)
	{
		//// Log.Debug(this.logGroup, `Constructing, symbol height ${this.symbolHeightInPixels}`)
		//this.reelWindowHeight = reelWindowHeight;

		this.acceleration = new Acceleration(this.logGroup);
		this.constantSpeed = new ConstantSpeed(this.logGroup);
		this.anticipation = new Anticipation(this.logGroup);
		this.decceleration = new Decceleration(this.logGroup);
		this.overshoot = new Overshoot(this.logGroup);

		/*
		 *	Acceleration
		 */
		let acceleration: Acceleration = new Acceleration(this.logGroup);
		this.acceleration = acceleration;

		// target reel speed in pixles/second? - in milliseconds, now() returns time in millis
		//acceleration.targetSpeed = speed;
		//if (speed == 0)
		acceleration.targetSpeed = 0.025 * this.symbolHeightInPixels * speedCorrection;

		// in what distance should we achieve target speet?x
		acceleration.targetDistance = 1 * this.symbolHeightInPixels;

		// how long will the animation took?
		acceleration.duration = 2 * acceleration.targetDistance / Math.abs(acceleration.targetSpeed);

		// acceleration
		acceleration.acceleration = acceleration.targetSpeed / acceleration.duration;


        /*
         *  Constant speed
         */
		let constantSpeed: ConstantSpeed = new ConstantSpeed(this.logGroup);
		this.constantSpeed = constantSpeed;

		constantSpeed.speed = acceleration.targetSpeed;

		// default distance, if not stopped and target set on time
		constantSpeed.minimumDistance = 4 * this.symbolHeightInPixels;
		constantSpeed.defaultDistance = 15 * this.symbolHeightInPixels;
		constantSpeed.targetDistance = 0;
		if (constantSpeed.defaultDistance < constantSpeed.minimumDistance)
			constantSpeed.defaultDistance = constantSpeed.minimumDistance;


		// //if(this.params.duration != 0)
		// {
		// 	let duration = constantSpeed.speed / constantSpeed.defaultDistance * this.params.durationCorrection;
		// 	constantSpeed.defaultDistance = Math.round((constantSpeed.speed * duration) / this.params.symbolHeight) * this.params.symbolHeight;
		// }

		// how far did we actually travel
		constantSpeed.currentDistance = 0;

		// delay for staggered stops, only used if spin is not interrupted
		//debugger;
		constantSpeed.delayDuration = 250.0 * this.params.columnIndex;
		if(delay != 0)
		{
			constantSpeed.delayDuration = delay * this.params.columnIndex;
		}
		constantSpeed.delayDistance = Math.round((constantSpeed.speed * constantSpeed.delayDuration) / this.symbolHeightInPixels) * this.symbolHeightInPixels;
		constantSpeed.delayDuration = constantSpeed.delayDistance / constantSpeed.speed;

        /*
         *	Anticipation
         *  	first set approx duration of anticipation, 
         *		then calculate distance, to match symbol height, 
         *		then calculate back exact duration, based on distance
         */
		this.anticipation.speed = 2 * this.constantSpeed.speed;
		this.anticipation.defaultDuration = 2000.0;
		this.anticipation.defaultDistance = Math.round((this.anticipation.speed * this.anticipation.defaultDuration) / this.symbolHeightInPixels) * this.symbolHeightInPixels;
		this.anticipation.defaultDuration = this.anticipation.defaultDistance / this.anticipation.speed;
		this.anticipation.Reset();


		/*
	 *	Decceleration, overshoot
	 */
		let decceleration: Decceleration = new Decceleration(this.logGroup);
		this.decceleration = decceleration;
		decceleration.startingSpeed = this.constantSpeed.speed;
		decceleration.overshootDistance = this.params.overshootHeightInSymbols;
		decceleration.distance = this.params.deccelerationHeightInSymbols * this.symbolHeightInPixels;
		decceleration.targetDistance = decceleration.distance + decceleration.overshootDistance;
		decceleration.duration = 2 * decceleration.targetDistance / decceleration.startingSpeed;
		decceleration.decceleration = -1 * decceleration.startingSpeed / decceleration.duration;



        /*
         *	Near complete - when symbols are slowing down and are visible, maybe 1 symbol left?
         */
		this.nearCompleteTargetDistance = decceleration.targetDistance; //(this.windowparams.symbolHeight -1) * this.params.symbolHeight;

        /*
         *	Overshoot correction, constant speed return
         */
		let overshoot: Overshoot = new Overshoot(this.logGroup);
		this.overshoot = overshoot;
		overshoot.distance = decceleration.overshootDistance;
		overshoot.speed = acceleration.targetSpeed / 20;
		overshoot.duration = overshoot.distance / overshoot.speed;

	}

	// Changing internal states
	// Each state has OnStateBegin and OnStateEnd in this class
	// TODO change to statemachine class
	private ChangeState(newState: S2_ReelSpinAnimState, silent: boolean = false) {
		let oldStateName = S2_ReelSpinAnimState[this.state];
		let oldStateEndFuncName = "On" + oldStateName + "End";

		let selfCallback: any = this[oldStateEndFuncName];

		if (!silent && this[oldStateEndFuncName] != null) {
			this[oldStateEndFuncName]();
		}

		//// Log.Debug(this.logGroup, "ChangeState(newState=" + S2_ReelSpinAnimState[newState] + ")");
		this.state = newState;
		this.lastStateTime = this.Now();

		let newStateName = S2_ReelSpinAnimState[this.state];
		let newStateBeginFuncName = "On" + newStateName + "Begin";

		if (!silent && this[newStateBeginFuncName] != null) {
			this[newStateBeginFuncName]();
		}
	}

	// support changing time speed
	protected prevTime: number = now();
	protected currentTime: number = 0;


	protected readonly normalSpeedFactor: number = 1.5;
	protected readonly acceleratedSpeedFactor: number = 6;
	protected speedFactor: number = this.normalSpeedFactor;
	
	// go from normal time factor to accelerated time factor in 0.05seconds (short time - fast response);
	protected warpSpeedAnim: TweenLite = TweenLite.fromTo(this, 0.05, {speedFactor: this.normalSpeedFactor}, {speedFactor: this.acceleratedSpeedFactor});

	protected Now() {
		let actualTime = now();
		this.currentTime += (actualTime - this.prevTime) * this.speedFactor;

		this.prevTime = actualTime;
		return this.currentTime;
	}


	protected lastUpdate: S2_ReelSpinAnimationUpdateParams = {
		reelSpinAnimation: this, 
		totalDistance: 0,
		modSymbolDistance: 0,
		symbolDistance: 0,
	};

	public Update() {

		// TODO must call update beacause of overlays!
		if (this.state == S2_ReelSpinAnimState.Idle)
		{
			// nothing to update
			//return;
		}

		let time: number = this.Now();
		let timeSinceLastState: number;
		timeSinceLastState = (time - this.lastStateTime);

		if (this.state == S2_ReelSpinAnimState.Created)
		{
			// force first time update
			this.ChangeState(S2_ReelSpinAnimState.Idle, true);
		}

		if (this.state == S2_ReelSpinAnimState.Acceleration) {

			// // Log.Debug("ACC", "t: " + timeSinceLastState + ", duration: " + timeSinceLastState + ", targetDuration: " + this.acceleration.duration);

			if (timeSinceLastState >= this.acceleration.duration) {
				// how far did we travel in this anim
				this.lastStateDistance += this.acceleration.targetDistance;
				this.ChangeState(S2_ReelSpinAnimState.ConstantSpeed);
			}
			else {
				// how far did we travel till now
				this.distance = this.lastStateDistance + this.acceleration.CalculateDistance(timeSinceLastState);
			}
		}

		timeSinceLastState = time - this.lastStateTime;

		if (this.state == S2_ReelSpinAnimState.ConstantSpeed) {

			let distance: number = this.constantSpeed.CalculateDistance(timeSinceLastState);
			this.constantSpeed.currentDistance = distance;

			// // Log.Debug("CONST", "t: " + timeSinceLastState + ", target: " + this.target + "; distance: " + distance +  "; targetDistance: " + this.constantSpeed.targetDistance + ";");

			if (!this.constantSpeed.passedMinimumDistance && distance >= this.constantSpeed.minimumDistance) {
				// just passed minimum distance, notify that stop request is now available
				this.constantSpeed.passedMinimumDistance = true;

				// as far as travel distance, stop request is available, 
				this.OnStopAvailable();
			}


			// do not stop without target
			if (this.targetSet && (
				// change state when target position and duration is set
				//((!this.reqAnticipation  && (timeSinceLastState >= this.constantSpeed.targetDuration  || this.stopRequest)) || this.previousReelSpinEnded)
				//!this.reqAnticipation && timeSinceLastState >= this.constantSpeed.targetDuration || (this.reqAnticipation)

				//(!this.reqAnticipation && timeSinceLastState >= this.constantSpeed.targetDuration + this.constantSpeed.delayDuration) || this.previousReelSpinEnded
				//(/*!this.reqAnticipation &&*/ timeSinceLastState >= (this.constantSpeed.targetDuration + this.constantSpeed.delayDuration)) || this.previousReelSpinEnded

				((timeSinceLastState >= (this.constantSpeed.targetDuration /*+ this.constantSpeed.delayDuration*/)) && (this.previousReelSpinEnded || !this.reqAnticipation || this.ColumnIndex == 0)) || this.stopRequest

				// if anticipation is requested, wait for previous to end 
				//	- skratch that, always wait for previous reel to finish
				//  - skratch that again, do not wait for previous reel to finish, takes too long
				//(/*!this.reqAnticipation || */ /*this.previousReelSpinEnded ||*/ /*this.stopRequest*/)
			)) {
				//// Log.Debug(this.logGroup, "target duration: " + (this.constantSpeed.targetDuration) + " delay duration: " + this.constantSpeed.delayDuration + " default distance: " + this.constantSpeed.defaultDistance);

				//debugger;
				// if we have anticipation, wait for previous reel to stop
				this.lastStateDistance += this.constantSpeed.targetDistance;
				if (this.reqAnticipation && !this.stopRequest) {
					this.ChangeState(S2_ReelSpinAnimState.Anticipation);
				}
				else {
					this.ChangeState(S2_ReelSpinAnimState.Decceleration);
				}
			}
			else {
				this.distance = this.lastStateDistance + distance;
			}
		}

		timeSinceLastState = time - this.lastStateTime;

		// TODO anticipation can be requested to stop early
		if (this.state == S2_ReelSpinAnimState.Anticipation) {
			let distance: number = this.anticipation.CalculateDistance(timeSinceLastState);
			this.anticipation.currentDistance = distance;

			// // Log.Debug("ANTICIPATION", "t: " + timeSinceLastState + "; distance: " + distance +  "; targetDistance: " + this.anticipation.targetDistance + ";");
			if (timeSinceLastState >= this.anticipation.targetDuration) {
				this.lastStateDistance += this.anticipation.targetDistance;
				this.ChangeState(S2_ReelSpinAnimState.Decceleration);
			}
			else {
				// how far did we travel till now
				this.distance = this.lastStateDistance + distance;
			}
		}

		timeSinceLastState = time - this.lastStateTime;

		if (this.state == S2_ReelSpinAnimState.Decceleration) {

			let distance: number = this.decceleration.CalculateDistance(timeSinceLastState);

			// // Log.Debug("DECC", "t: " + timeSinceLastState + "; distance: " + distance +  "; targetDistance: " + this.decceleration.targetDistance + ";");


			/*
			if (this.nearCompleteDistance >= distance && !this.nearCompleteTriggeredFlag) {
				this.nearCompleteTriggeredFlag = true;
				this.OnNearComplete();
			}
			*/

			if (timeSinceLastState >= this.decceleration.duration) {
				this.lastStateDistance = this.lastStateDistance + this.decceleration.targetDistance;
				this.OnNearComplete();
				this.ChangeState(S2_ReelSpinAnimState.Overshoot);
			}
			else {
				// how far did we travel till now
				this.distance = this.lastStateDistance + distance;
			}
		}

		timeSinceLastState = time - this.lastStateTime;

		if (this.state == S2_ReelSpinAnimState.Overshoot) {

			let distance: number = -1 * this.overshoot.CalculateDistance(timeSinceLastState);

			// // Log.Debug("OVER", "t: " + timeSinceLastState + "; distance: " + distance +  "; targetDistance: " + this.overshoot.distance + "; duration: " + this.overshoot.duration);

			if (timeSinceLastState >= this.overshoot.duration) {
				//this.lastStateDistance -= this.overshoot.distance;

				// this is the last state, so set exact distance
				this.distance = this.lastStateDistance;

				// spin is finished
				this.ChangeState(S2_ReelSpinAnimState.Finished);
			}
			else {
				this.distance = this.lastStateDistance + distance;
			}
		}

		if (this.state == S2_ReelSpinAnimState.Finished)
		{
			let symbolsDistance = Math.round(this.distance / this.symbolHeightInPixels) * this.symbolHeightInPixels;
			this.distance = Math.round(symbolsDistance * 1000) / 1000;

			this.ChangeState(S2_ReelSpinAnimState.Idle);
        }
        
        {
            let distance = Math.roundTo(this.distance, 3);

            let symbolDistance = Math.floor(distance / this.symbolHeightInPixels);
            let modSymbolDist = distance - (symbolDistance * this.symbolHeightInPixels);

			
			this.lastUpdate.totalDistance = distance;
			this.lastUpdate.modSymbolDistance = modSymbolDist;
			this.lastUpdate.symbolDistance = symbolDistance;
			this.OnUpdate(this.lastUpdate);
        }
	}

	public Start(): void {
		if (this.state == S2_ReelSpinAnimState.Idle) {
			//// Log.Debug(this.logGroup, "Starting");

			// clear everything, before changing state
			this.targetSet = false;
			this.stopRequest = false;
			this.reqAnticipation = false;
			this.constantSpeed.Reset();
			this.anticipation.Reset();
			this.lastStateDistance = 0;
			this.distance = 0;

			this.speedFactor = this.normalSpeedFactor;
			this.warpSpeedAnim.kill();

			this.nearCompleteTriggeredFlag = false;

			// first reel has no previous reels
			if (this.ColumnIndex == 0) {
				this.previousReelSpinEnded = true;
			}
			else {
				this.previousReelSpinEnded = false;
			}

			this.ChangeState(S2_ReelSpinAnimState.Acceleration);
		}
		else {
			// Log.Debug(this.logGroup, "Already running");
		}
	}

	public Stop(): void {

	}

	public AddOnUpdateCallback(callback: S2_ReelSpinAnimationUpdateCallback): void {
		this.onUpdateCallbacks.push(callback);
	}

	private OnUpdate(params: S2_ReelSpinAnimationUpdateParams): void {
		for (let i = 0; i < this.onUpdateCallbacks.length; i++) {
            this.onUpdateCallbacks[i](params);
        }
	}

	public AddOnStopAvailableCallback(callback: (reelIndex: number) => void) {
		this.onStopAvailableCallbacks.push(callback);
	}

	public CheckStopAvailable(): boolean {
		let available: boolean = false;

		// stop request is available, if target is set and minimum distance has been traveled
		//if (this.targetSet && this.constantSpeed.passedMinimumDistance) {
		if (this.targetSet) {
			available = true
		}
		else {
			// stop request not yet available
		}

		return available;
	}

	private OnStopAvailable(): void {
		if (this.CheckStopAvailable()) {

			//// Log.Debug(this.logGroup, "Stop request is now available, notifying");

			for (let i = 0; i < this.onStopAvailableCallbacks.length; i++) {
				this.onStopAvailableCallbacks[i](this.ColumnIndex);
			}
		}
	}

	private nearCompleteCallbacks: S2_ReelSpinAnimationNearCompleteCallback[] = []
	public AddOnNearCompleteCallback(callback: S2_ReelSpinAnimationNearCompleteCallback) {
		this.nearCompleteCallbacks.push(callback);
	}

	private OnNearComplete() {
		for (let i = 0; i < this.nearCompleteCallbacks.length; i++) {
			this.nearCompleteCallbacks[i](this);
		}
	}


	public AddOnCompleteCallback(callback: S2_ReelSpinAnimationCompleteCallback) {
		this.onCompleteCallbacks.push(callback);
	}

	private OnIdleBegin() {
		this.OnComplete();
	}

	private OnComplete(): void {
		for (let i = 0; i < this.onCompleteCallbacks.length; i++) {
			this.onCompleteCallbacks[i](this);
		}
	}


	public AddOnAnticipationBeginCallback(callback: () => void) {
		this.onAnticipationBeginCallbacks.push(callback);
	}

	private OnAnticipationBegin() {
		for (let i = 0; i < this.onAnticipationBeginCallbacks.length; i++) {
			this.onAnticipationBeginCallbacks[i](new AnticipationParams(this.ColumnIndex));
		}
	}

	public AddOnAnticipationEndCallback(callback: () => void) {
		this.onAnticipationEndCallbacks.push(callback);
	}

	private OnAnticipationEnd() {
		for (let i = 0; i < this.onAnticipationEndCallbacks.length; i++) {
			this.onAnticipationEndCallbacks[i](new AnticipationParams(this.ColumnIndex));
		}
	}

	public OnPreviousReelSpinEnd() {
		// when previous reel stops spinning, this reel can begin decceleration
		// Log.Debug(this.logGroup, "Previous reel spin has ended");

		this.previousReelSpinEnded = true;

		// previous reel has ended, now this reel can enter anticipation state, or deccelerate, whatever
		//this.constantSpeed.SetDefaultDistance(this.symbolHeightInPixels, true);
	}

	private onSpinEndCallbacks: (() => void)[] = [];
	public AddSpinEndCallback(callback: () => void) {
		this.onSpinEndCallbacks.push(callback)
	}

	public RequestStop(): void {

		if (this.CheckStopAvailable()) {
			if (!this.stopRequest) {

				// everything is ready for early stop, set new target distance
				// Log.Debug(this.logGroup, "Stop requested");
				this.stopRequest = true;

				let constantSpeedTargetDistance = Math.ceil(this.constantSpeed.currentDistance / this.symbolHeightInPixels) * this.symbolHeightInPixels;
				//this.constantSpeed.SetTargetDistance(constantSpeedTargetDistance);

				// if we're in anticipation state, also end that
				//if (this.state == S2_ReelSpinAnimState.Anticipation) {
				let anticipationTargetDistance = Math.ceil(this.anticipation.currentDistance / this.symbolHeightInPixels) * this.symbolHeightInPixels;
				this.anticipation.SetTargetDistance(anticipationTargetDistance);

				//this.speedFactor = this.acceleratedSpeedFactor;
				this.warpSpeedAnim.restart();
				//}
			}
			else {
				// Log.Debug(this.logGroup, "Already requested");
			}
		}
		else {
			// Log.Debug(this.logGroup, "Stop not yet available");
		}
	}

	public SetTarget(anticipation: boolean): void {

		// Log.Debug(this.logGroup, "Target set, anticipation: " + anticipation);
		this.targetSet = true;

		// first reel has no anticipation
		if (this.ColumnIndex != 0) {
			this.reqAnticipation = anticipation;
		}

		//this.constantSpeed.SetDefaultDistance(this.symbolHeightInPixels);

		this.CheckStopAvailable();
	}

	public GetDistance(): number {
		return this.distance;
	}

	public AddOnStartCallback(callback: S2_ReelSpinAnimationStartCallback): void {
		this.onStartCallbacks.push(callback);
	}

	private OnAccelerationBegin() {
		for (let i = 0; i < this.onStartCallbacks.length; i++) {
			this.onStartCallbacks[i](this);
		}

		this.startTime = this.Now();
	}

	// decceleration
	private onDeccelerationStartedCallbacks: S2_ReelSpinAnimationDeccelerationCallback[] = [];

	private OnDeccelerationBegin() {

		let totalDistance = this.lastStateDistance + this.decceleration.targetDistance;
		let params: S2_OnDeccelerationParams = new S2_OnDeccelerationParams(
			totalDistance,
			Math.floor(totalDistance / this.symbolHeightInPixels)
		);

		for (let i = 0; i < this.onDeccelerationStartedCallbacks.length; i++) {
			this.onDeccelerationStartedCallbacks[i](this, params);
		}

		this.nearCompleteDistance = this.lastStateDistance + this.nearCompleteTargetDistance;
	}

	public AddOnDeccelerationCallbak(callback: S2_ReelSpinAnimationDeccelerationCallback): void {
		this.onDeccelerationStartedCallbacks.push(callback);
	}
	public UpdateSpinSpeed(speedParams: SpinAnimParams)
	{
		this.CalculateAnimation(speedParams.Delay,speedParams.SpeedCorrection);
	}

	public Destroy()
	{
		this.onStartCallbacks = null;
		this.onCompleteCallbacks = null;
		this.onStopAvailableCallbacks = null;
		this.onUpdateCallbacks = null;
	
		this.onAnticipationBeginCallbacks = null;
		this.onAnticipationEndCallbacks = null;
	}
}
// }
